import { createContext, useState, useEffect, useContext } from 'react'
import { identifyUser } from '../services/analytics'
import { updateUser } from '../services/user'
import { isEqual, isObjEmpty } from '../utils'
import usePrevious from '../hooks/usePrevious'

const UserContext = createContext({})

function UserProvider ({ children }) {
  const [user, setUser] = useState({})
  const prevUser = usePrevious(user)

  // Restore user data if in Local Storage
  // useEffect(() => {
  //   const userData = JSON.parse(localStorage.getItem('user'))
  //   if (userData) {
  //     setUser(userData)
  //   }
  // }, [])

  // Save user data into Local Storage
  useEffect(() => {
    // localStorage.setItem('user', JSON.stringify(user))
    let { uid } = user
    // Ensure the user already exists and not just being restored from localstorage
    if (uid && !isObjEmpty(prevUser) && !isEqual(user, prevUser)) {
      console.log('Saving user to db...', uid)
      updateUser(uid, user)
      identifyUser(uid, user)
    }
  }, [user])

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  )
}

function useUser () {
  const context = useContext(UserContext)
  // if (context === {}) {
  //   throw new Error('useUser must be used within a UserProvider')
  // }
  return context
}

export { UserProvider, useUser }
